import React from 'react';
import DOMPurify from 'dompurify';

type ProviderProfileProps = {
  name?: string;
  credentials?: string;
  bio?: string;
  imageUrl?: string;
  city?: string;
  state?: string;
};

const ProviderProfileView: React.FC<ProviderProfileProps> = ({ name, credentials, bio, imageUrl, city, state }) => {
  console.log('imageUrl', imageUrl);
  if (!name) return null;
  return (
    <div className="flex items-start font-sans">
      {imageUrl && (
        <img
          data-testid="provider-image"
          src={imageUrl}
          alt={name}
          className="min-h-[300px] max-w-[50%] max-h-full rounded-lg mr-5 object-cover"
        />
      )}
      <div className="max-w-xl">
        <h3 className="text-2xl font-bold heading heading--medium heading--black">Your Provider</h3>
        <h2 data-testid="provider-name-creds" className="text-xl font-bold mb-2">
          {name}
          {credentials && `, ${credentials}`}
        </h2>
        <h3 className="font-light profile-credentials">Board-Certified Advanced Practice Provider</h3>
        {bio && (
          <p
            data-testid="provider-bio"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(bio, { USE_PROFILES: { html: true } }) }}
          />
        )}
      </div>
    </div>
  );
};

export default ProviderProfileView;
